/** @format */

import { createBrowserHistory } from 'history';

export const history = createBrowserHistory();
history.respectModifierPush = (event, uri) => {
    //Handle no passed event
    if (typeof event === 'undefined') {
        history.push(uri);
        return;
    }

    //Received event, do normal procedure
    event.persist();
    if (event.ctrlKey || event.button === 1) {
        window.open(uri);
    } else {
        history.push(uri);
    }
};
